import AppCardOneGridLayout from './AppCardOneGridLayout.vue';

export default AppCardOneGridLayout;



// WEBPACK FOOTER //
// ./src/uikit/layouts/cardlayouts/CardOneGridLayout/index.ts